export default __webpack_public_path__ + "static/10 - Kábelek rendszerezése-6d08feea17ab7364bcdda4c02e412aa4.jpg";